import React, { useState, useEffect } from 'react';
import ComboBoxSelect from './ComboBoxSelect';

const CBS_SoftSkills = ({
  criteria,
  onCriteriaChange,
  label = "Select or add soft skills for this evaluation",
  placeholder = "Type to add custom soft skills...",
  showWarning = false
}) => {

  // Extract soft skills from criteria
  const getInitialSoftSkills = () => {
    if (criteria?.softSkills?.items) {
      return criteria.softSkills.items.map((item) => ({
        value: item.skill.toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, ''),
        label: item.skill,
        color: '#3b82f6'
      }));
    }
    return [];
  };

  // State for selected soft skills
  const [selectedSkills, setSelectedSkills] = useState(getInitialSoftSkills());

  // Update selected skills when criteria changes
  useEffect(() => {
    setSelectedSkills(getInitialSoftSkills());
  }, [criteria]);

  // Update soft skills criteria JSON
  const updateSoftSkillsCriteria = (newSelectedSkills) => {
    if (!criteria) return;

    // Create updated criteria with new soft skills
    const updatedCriteria = {
      ...criteria,
      softSkills: {
        ...criteria.softSkills,
        items: newSelectedSkills.map(skill => {
          // Check if this skill already exists in our current criteria
          const existingSkill = criteria.softSkills?.items?.find(
            item => item.skill === skill.label
          );
          
          if (existingSkill) {
            // Keep existing skill with all its properties
            return existingSkill;
          } else {
            // Create new skill entry with softSkills specific structure (no importance field)
            return {
              skill: skill.label,
              context: []
            };
          }
        })
      }
    };

    // Call parent callback with only the updated criteria
    onCriteriaChange(updatedCriteria);
  };

  // Handle skill selection change
  const handleSkillChange = (newValue, actionMeta) => {
    const newSelectedSkills = newValue || [];
    setSelectedSkills(newSelectedSkills);
    updateSoftSkillsCriteria(newSelectedSkills);
  };

  // Handle creating new skill option
  const handleCreateOption = (inputValue) => {
    const newOption = {
      value: inputValue.toLowerCase().replace(/\s+/g, '-'),
      label: inputValue,
      color: '#3b82f6',
      __isNew__: true
    };
    const updatedSkills = [...selectedSkills, newOption];
    setSelectedSkills(updatedSkills);
    updateSoftSkillsCriteria(updatedSkills);
  };

  return (
    <div className="mb-6">
      <ComboBoxSelect
        value={selectedSkills}
        onChange={handleSkillChange}
        options={[]} // No autocomplete options for soft skills - manual entry only
        placeholder={placeholder}
        label={label}
        onCreateOption={handleCreateOption}
      />
      {showWarning && (
        <div className="flex items-center justify-end gap-1 -mt-2 mb-2 text-xs text-red-600">
          <span>⚠️</span>
          <span>Over 10 items may reduce evaluation accuracy.</span>
        </div>
      )}
    </div>
  );
};

export default CBS_SoftSkills;
